import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteCoreApiGatewayKeysByIdSlice } from './delete';
import { patchCoreApiGatewayKeysByIdSlice } from './patch';

export const coreApiGatewayKeysByIdReducers = combineReducers({
	delete: deleteCoreApiGatewayKeysByIdSlice.asyncReducers,
	patch: patchCoreApiGatewayKeysByIdSlice.asyncReducers
});

export const coreApiGatewayKeysByIdWatchers = combineAllWatchers([
	deleteCoreApiGatewayKeysByIdSlice.asyncWatchers,
	patchCoreApiGatewayKeysByIdSlice.asyncWatchers
]);
